import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TokenService } from '../core/token/token.service';

@Injectable({
  providedIn: 'root'
})
export class BibliotecaScriptService {
  private apiUrl = environment.apiGestorUrlLocal;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() }),
    params: {}
  };

  constructor(private http: HttpClient, private tokenService: TokenService) { }

  listaBibliotecaScript(params, filtros): Observable<any> {
    this.httpOptions.params = params;
    return this.http.post(`${this.apiUrl}api/scripts/biblioteca/lista`, filtros, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  dropDownList(): Observable<any> {
    this.httpOptions.params = "";
    return this.http.get(`${this.apiUrl}api/scripts/biblioteca/dropdownlist`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  delete(id): Observable<any> {
    this.httpOptions.params = "";
    return this.http.delete(`${this.apiUrl}api/scripts/${id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  create(payload): Observable<any> {
    this.httpOptions.params = "";
    return this.http.post(`${this.apiUrl}api/scripts`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  update(payload): Observable<any>{
    this.httpOptions.params = "";
    return this.http.put(`${this.apiUrl}api/scripts`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  createPasta(payload): Observable<any> {
    this.httpOptions.params = '';
    return this.http.post(`${this.apiUrl}api/scripts/biblioteca`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('Ops! Ocorreu um erro:', error.error);
    } else {
      console.error(
        `Backend retornou o código ${error.status}, ` +
        `o body é:`, error);
    }
    return throwError(
      error.error);
  }
}
